<template>
    <div>
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
			<div class="mx-25">
				<a-row type="flex" :gutter="24">
					<a-col :span="24" :md="2">
						<a-button
						@click="$router.push({ name: 'Core Data Create', params: { data: { columns: columns, api_route: 'phraseresponse/addNewPhraseResponse' } } })"
						class="btn btn-primary">
						<a-icon type="create" theme="filled" /> Create New
						</a-button>
					</a-col>
					<a-col :span="24" :md="10">
						<a-select v-model="pageSize2" @change="onPageSize2Change" style="width: 70px">
							<a-select-option value="5">5</a-select-option>
							<a-select-option value="10">10</a-select-option>
							<a-select-option value="15">15</a-select-option>
							<a-select-option value="20">20</a-select-option>
							<a-select-option value="25">25</a-select-option>
						</a-select>
						<label for="" class="ml-10">entries per page</label>
					</a-col>
					<a-col :span="24" :md="12" class="text-right">
    					<a-input-search placeholder="smart search" style="max-width: 200px;" v-model="query" @change="onSearchChange" />
					</a-col>
				</a-row>
			</div>
			
			<a-table class="mt-20" :columns="columns" :data-source="data" :pagination="{pageSize: pageSize2,}" :key="id">	
				<template slot="editBtn" slot-scope="row">
					<a-tooltip>
						<template slot="title">Edit Phrase Response</template>
						<!--            @click="$router.push({name: 'Classifications Edit', params: {id: row.id}})"-->
						<a-button :data-id="row.key"
							@click="$router.push({ name: 'Core Data Edit', params: { data: { row: row, columns: columns, api_route: 'phraseresponse/updatePhraseResponse' } } })">
							<a-icon type="edit" theme="outlined" /> Edit
						</a-button>
					</a-tooltip>
				</template>
				<template slot="deleteBtn" slot-scope="row">
					<a-tooltip>
						<template slot="title">Delete Phrase Response</template>
						<!-- <modalDelete @deleteVendor="deleteVendor" :row="row" /> -->
					</a-tooltip>
				</template>
			</a-table>
		</a-card>
    </div>
</template>

<script>
	// Second table's list of columns.
	const columns = [
		{
			title: 'Id',
			dataIndex: 'id',
			// sorter: (a, b) => a.vendorName.length - b.vendorName.length,
			sortDirections: ['descend', 'ascend'],
		},
		{
			title: 'Response Info',
			dataIndex: 'response_info',
			//sorter: (a, b) => a.response_info.length - b.response_info.length,
			sortDirections: ['descend', 'ascend'],
		},
		{
		title: 'Actions',
		scopedSlots: { customRender: 'editBtn' },
	},
	];
	
	// Second table's list of rows.
 	// import modalDelete from './VendorDelete.vue';
	const data = [];
	 
	export default {
		components: {
			//modalDelete
		},
		data() {
			return {
				// Second table's list of columns.
				columns,

				data,

				// First table's number of rows per page.
				pageSize: 10,

				// Second table's number of rows per page.
				pageSize2: 10,
				
				// Second table's search query.
				query: ''

			}
		},
		methods: {
			// Event handler for first table's size change.
			onPageSizeChange() {
				this.pageSize = parseInt( this.pageSize ) ;
			},

			// Event handler for second table's size change.
			onPageSize2Change() {
				this.pageSize2 = parseInt( this.pageSize2 ) ;
			},

			//delete vendor modal 
			deleteVendor(id){
				// Connect to API to delete from DB
				this.$store.dispatch('phraseresponses/phraseresponse_info', id);

				// refresh the list of vendors
				this.$store.dispatch('phraseresponses/getAll');
			},

			// Event handler for second table's search.
			onSearchChange() {
				if( this.query.length > 0 ) {
					this.data = this.data.filter( (row) => {
						for( const key in row ) {
							if( String( row[key] ).toLowerCase().indexOf( this.query.toLowerCase() ) > -1 ) {
								return true;
							}
						}
						return false;
					}) ;
				}
				else {
					this.data = this.phraseresponses;
				}
			},
			
		},
		computed: {
			phraseresponses: {
				get() {
					return this.$store.state.phraseresponses.phraseresponses;
				}
			}
		},
  		created () {
    		this.$store.dispatch('phraseresponses/getAll').then(()=> {
				this.data = this.phraseresponses;
				//console.log("data" + this.phraseresponses)
			})
  		}
	}
</script>

<style lang="scss">
</style>